import api from "@/api";
import esupplyvetApi from "@/api/esupplyvet";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Récupère toutes les adresses du client connecté
 * @returns {Promise} Réponse de l'API contenant la liste des adresses
 */
export function getAddresses(userRole = "", vetId = null) {
  let url = "/addresses";

  console.log("Selected Vet ID:", vetId);
  console.log("User Role:", userRole);
  
  // Add query parameters for delegates
  if (userRole === "delegues" && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `?${params.toString()}`;
  }
  
  return getHttpClient().get(url);
}
/**
 * Récupère une adresse par son ID
 * @param {number} addressId - ID de l'adresse
 * @returns {Promise} Réponse de l'API contenant les infos d'adresse
 */
export function getAddress(addressId) {
  return getHttpClient().get(`/addresses/${addressId}`);
}

/**
 * Met à jour une adresse par son ID
 * @param {number} addressId - ID de l'adresse
 * @param {Object} addressData - Données d'adresse à mettre à jour
 * @returns {Promise} Réponse de l'API
 */
export function updateAddress(addressId, addressData) {
  return getHttpClient().put(`/addresses/${addressId}`, addressData);
}

/**
 * Crée une nouvelle adresse
 * @param {Object} addressData - Données d'adresse à créer
 * @returns {Promise} Réponse de l'API
 */
export function createAddress(addressData) {
  return getHttpClient().post("/addresses", addressData);
}

/**
 * Supprime une adresse par son ID
 * @param {number} addressId - ID de l'adresse à supprimer
 * @returns {Promise} Réponse de l'API
 */
export function deleteAddress(addressId) {
  return getHttpClient().delete(`/addresses/${addressId}`);
}
